// An optional API host to prefix paths with.
const API_HOST = '/api';

function checkStatus(json) {
  if (json.error !== undefined) {
    throw json;
  }

  return json;
}

function parseJSON(response) {
  return response.text().then((text) => {
    if (text) {
      return JSON.parse(text);
    } else {
      return text;
    }
  })
}

/**
 * The API helper for dealing with the Normal Accounts backend.
 * Adds in necessary headers for interacting with the API, as well as
 * properly parses + resolves/rejects responses/errors in JSON.
 *
 * Simply wraps whatwg-fetch for easy promise-based XHR.
 *
 * @param {string} path - The path of the request.
 * @param {Object} options - The options for the request.
 * @param {string} options.method - The method for the request. Defaults to GET.
 * @param {string|Object} options.body - The optional body for the request.
 * @param {Object} options.headers - The extra headers for the request.
 * @param {string} options.credentials - The authentication credentials mode. Defaults to "omit".
 * @returns {Promise}
 */
export default function api(path, options) {
  let defaultOptions = {
    headers: {
      'Content-Type': 'application/json'
    }
  };

  let fetchOptions = Object.assign({}, defaultOptions, options);
  let url = `${API_HOST}${path}`;

  console.debug(`Fetching ${url} with options:`, fetchOptions);
  return new Promise((resolve, reject) => {
    fetch(url, fetchOptions)
      .then(parseJSON)
      .then(checkStatus)
      .then((data) => resolve(data))
      .catch((err) => reject(err));
  })
}



// WEBPACK FOOTER //
// ./src/utils/api.js